import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Col, Tab, Nav, Badge } from 'react-bootstrap';
import $ from 'jquery';
import axios from 'axios';

import imcoming_call from '../../../../images/manage_calls/incoming_call.ico';
import outgoing_call from '../../../../images/manage_calls/outgoing_call.ico';
import dialed_call from '../../../../images/manage_calls/dialed_call.ico';
import missed_call from '../../../../images/manage_calls/missed_call.ico';
import rejected_call from '../../../../images/manage_calls/reject_call.ico';

import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

const Cronjob_logs = ({ show, onClose, data }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [key, setKey] = useState('incoming');

    const [datas, setData] = useState([]);
    const [outgoing, setOutgoing] = useState([]);
    const [missed, setmissed] = useState([]);
    const [dailed, setdailed] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(10);
    const [total_entries, setTotslEntries] = useState(0);
    const [loading, setLoading] = useState(false);

    const [incommingCalls, setIncommingCalls] = useState(0);
    const [Outgoingcalls, setOutgoingCalls] = useState(0);
    const [DailedCalls, setDailedCalls] = useState(0);
    const [missedCalls, setMissedCalls] = useState(0);

    // fetch count
    const fetchcount = () => {
        axios.get(`${baseURL}/get_lead_calls/count/${data.sno}`)
            .then(response => {
                setIncommingCalls(response.data.incomingCount);
                setOutgoingCalls(response.data.outgoingCount);
                setDailedCalls(response.data.missedCount);
                setMissedCalls(response.data.dialedCount);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });
    }

    useEffect(() => {
        if(data){
            fetchcount();
        }
    }, [data]);

    // page table data fetch
    const fetchData = () => {
        setLoading(true);
        setData([]);
        setOutgoing([]);
        setmissed([]);
        setdailed([]);
        setHasFetched(false);

        const params = {
            page,
            per_page: perPage,
            search: searchTerm,
        };

        if (key === "incoming") {
            axios.get(`${baseURL}/get_lead_calls/incoming/${data.sno}`, { params: params })
                .then(response => {
                    setData(response.data.data);
                    setHasFetched(true);
                    setTotalPages(response.data.last_page);
                    setTotslEntries(response.data.total);
                    setLoading(false);
                })
                .catch(error => {
                    console.log('There was an error fetching the data!', error);
                    setHasFetched(true);
                    setLoading(false);
                });
        }

        if (key === "outgoing") {
            axios.get(`${baseURL}/get_lead_calls/outgoing/${data.sno}`, { params: params })
                .then(response => {
                    setOutgoing(response.data.data);
                    setHasFetched(true);
                    setTotalPages(response.data.last_page);
                    setTotslEntries(response.data.total);
                    setLoading(false);
                })
                .catch(error => {
                    console.log('There was an error fetching the data!', error);
                    setHasFetched(true);
                    setLoading(false);
                });
        }

        if (key === "missed") {
            axios.get(`${baseURL}/get_lead_calls/missed/${data.sno}`, { params: params })
                .then(response => {
                    setmissed(response.data.data);
                    setHasFetched(true);
                    setTotalPages(response.data.last_page);
                    setTotslEntries(response.data.total);
                    setLoading(false);
                })
                .catch(error => {
                    console.log('There was an error fetching the data!', error);
                    setHasFetched(true);
                    setLoading(false);
                });
        }

        if (key === "dailed") {
            axios.get(`${baseURL}/get_lead_calls/dailed/${data.sno}`, { params: params })
                .then(response => {
                    setdailed(response.data.data);
                    setHasFetched(true);
                    setTotalPages(response.data.last_page);
                    setTotslEntries(response.data.total);
                    setLoading(false);
                })
                .catch(error => {
                    console.log('There was an error fetching the data!', error);
                    setHasFetched(true);
                    setLoading(false);
                });
        }

    };

    // fetch data & leadstatus
    useEffect(() => {
        if (data) {
            fetchData();
        }
    }, [page, searchTerm, perPage, data, key]);

    // display func
    function capitalizeFirstLetter(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    // call image
    const renderCallStatusContent = (status) => {
        switch (status) {
            case 0:
                return (
                    <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                        <div data-src={outgoing_call} className="border rounded px-1 py-0">
                            <img src={outgoing_call} alt="call" className="cursor-pointer w-35px h-35px" />
                        </div>
                    </LightGallery>
                );
            case 1:
                return (
                    <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                        <div data-src={imcoming_call} className="border rounded px-1 py-0">
                            <img src={imcoming_call} alt="call" className="cursor-pointer w-35px h-35px" />
                        </div>
                    </LightGallery>
                );
            case 2:
                return (
                    <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                        <div data-src={missed_call} className="border rounded px-1 py-0">
                            <img src={missed_call} alt="call" className="cursor-pointer w-35px h-35px" />
                        </div>
                    </LightGallery>
                );
            case 3:
                return (
                    <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                        <div data-src={rejected_call} className="border rounded px-1 py-0">
                            <img src={rejected_call} alt="call" className="cursor-pointer w-35px h-35px" />
                        </div>
                    </LightGallery>
                );
            case 4:
                return (
                    <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                        <div data-src={dialed_call} className="border rounded px-1 py-0">
                            <img src={dialed_call} alt="call" className="cursor-pointer w-35px h-35px" />
                        </div>
                    </LightGallery>
                );
            default:
                return null;
        }
    };

    // format date display
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // disp time format
    function convert24to12(time24) {
        if (time24) {
            const [hourStr, minute, second] = time24.split(':');
            let hour = parseInt(hourStr, 10);

            const ampm = hour >= 12 ? 'PM' : 'AM';
            hour = hour % 12;
            if (hour === 0) hour = 12;

            // Pad minute and second if needed
            const paddedMinute = minute.padStart(2, '0');
            const paddedSecond = second.padStart(2, '0');

            return `${hour}:${paddedMinute}:${paddedSecond} ${ampm}`;
        } else {
            return '';
        }
    };

    return (
        <Modal show={show} size="xl">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">{capitalizeFirstLetter(data.lead_name)} - {data.mobile_no}</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>

                <Col xl={12} className='mb-2 mt-3 px-4'>
                    <div className="custom-tab-1 ">
                        <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                            <Nav as="ul" className="nav-tabs">
                                <Nav.Item as="li" >
                                    <Nav.Link eventKey="incoming">
                                        <div className="d-flex align-items-center justify-content-start gap-2">
                                            <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                <div data-src={imcoming_call} className="border rounded px-1 py-0">
                                                    <img src={imcoming_call} alt="call" className="cursor-pointer w-35px h-35px" />
                                                </div>
                                            </LightGallery>
                                            <label className="ms-2 fs-6">
                                                Incoming Calls
                                            </label>
                                            <Badge as="a" href="" bg=" badge-circle" className='badge-outline-success ms-2 fw-bold fs-8'>
                                                {incommingCalls}
                                            </Badge>
                                        </div>
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" >
                                    <Nav.Link eventKey="outgoing">
                                        <div className="d-flex align-items-center justify-content-start gap-2">
                                            <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                <div data-src={outgoing_call} className="border rounded px-1 py-0">
                                                    <img src={outgoing_call} alt="call" className="cursor-pointer w-35px h-35px" />
                                                </div>
                                            </LightGallery>
                                            <label className="ms-2 fs-6">
                                                Outgoing Calls
                                            </label>
                                            <Badge as="a" href="" bg=" badge-circle" className='badge-outline-warning ms-2 fw-bold fs-8'>
                                                {Outgoingcalls}
                                            </Badge>
                                        </div>
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" >
                                    <Nav.Link eventKey="missed">
                                        <div className="d-flex align-items-center justify-content-start gap-2">
                                            <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                <div data-src={rejected_call} className="border rounded px-1 py-0">
                                                    <img src={rejected_call} alt="call" className="cursor-pointer w-35px h-35px" />
                                                </div>
                                            </LightGallery>
                                            <label className="ms-2 fs-6">
                                                Missed & Rejected
                                            </label>
                                            <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                                {missedCalls}
                                            </Badge>
                                        </div>
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" >
                                    <Nav.Link eventKey="dailed">
                                        <div className="d-flex align-items-center justify-content-start gap-2">
                                            <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                <div data-src={dialed_call} className="border rounded px-1 py-0">
                                                    <img src={dialed_call} alt="call" className="cursor-pointer w-35px h-35px" />
                                                </div>
                                            </LightGallery>
                                            <label className="ms-2 fs-6">
                                                Dialed Calls
                                            </label>
                                            <Badge as="a" href="" bg=" badge-circle" className='badge-outline-info ms-2 fw-bold fs-8'>
                                                {DailedCalls}
                                            </Badge>
                                        </div>
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>

                            <Tab.Content className="pt-4">
                                <Tab.Pane eventKey="incoming">
                                    <div className="table-container">

                                        <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd' }}>
                                            <thead>
                                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                    <th className='min-w-80px'>Communicator</th>
                                                    <th className='min-w-100px'>Call Date</th>
                                                    <th className='min-w-100px'>Start Time</th>
                                                    <th className='min-w-100px'>End Time</th>
                                                    <th className='min-w-80px'>Duration</th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-gray-600 fw-semibold fs-7">
                                                {datas.length === 0 && hasFetched ? (
                                                    <tr>
                                                        <td colSpan="5" className="text-center text-muted py-2">
                                                            No data available
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    <>
                                                        {datas.map((data, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <div className="d-flex align-items-center justify-content-start gap-2">
                                                                        {renderCallStatusContent(data.call_status)}
                                                                        <div className='mb-0'>
                                                                            <label className='text-black font-w400 fs-7'>{data.staff_name}</label>
                                                                            <div className="d-block">
                                                                                <div className="fs-8 font-w600 text-dark">{data.staff_phone_no}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className='align-content-center'>
                                                                    <div className='text-black font-w400 fs-7  mw-75'>{formatDate(data.call_start_date)}</div>
                                                                </td>
                                                                <td className='align-content-center'>
                                                                    <div className='text-info font-w400 fs-7  mw-75'>{convert24to12(data.call_start_time)}</div>
                                                                </td>
                                                                <td className='align-content-center'>
                                                                    <div className='text-danger font-w400 fs-7  mw-75'>{convert24to12(data.call_end_time)}</div>
                                                                </td>
                                                                <td className='align-content-center'>
                                                                    <Badge bg="warning" className='text-white fs-7 font-w400 mw-75'>{data.call_duration}</Badge>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </>
                                                )}

                                                {loading && (
                                                    <tr>
                                                        <td colSpan="5" className="text-center text-muted py-2">
                                                            Loading
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>

                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            {/* Bottom left: Showing x to y of z entries */}
                                            <div>
                                                {datas.length > 0 ? (
                                                    <span className="text-muted">
                                                        Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                                    </span>
                                                ) : (
                                                    <span className="text-muted">
                                                        Showing 0 to 0 of 0 entries
                                                    </span>
                                                )}
                                            </div>

                                            {/* Bottom right: Pagination */}
                                            <nav>
                                                <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                    {/* Previous Button */}
                                                    <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                                            Previous
                                                        </button>
                                                    </li>

                                                    {/* First Page */}
                                                    <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                                            1
                                                        </button>
                                                    </li>

                                                    {/* Left Ellipsis */}
                                                    {page > 4 && (
                                                        <li className="page-item disabled">
                                                            <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                        </li>
                                                    )}

                                                    {/* Pages Around Current */}
                                                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                        .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                                        .map(p => (
                                                            <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                                    {p}
                                                                </button>
                                                            </li>
                                                        ))}

                                                    {/* Right Ellipsis */}
                                                    {page < totalPages - 3 && (
                                                        <li className="page-item disabled">
                                                            <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                        </li>
                                                    )}

                                                    {/* Last Page */}
                                                    {totalPages > 1 && (
                                                        <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                                                {totalPages}
                                                            </button>
                                                        </li>
                                                    )}

                                                    {/* Next Button */}
                                                    <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                                            Next
                                                        </button>
                                                    </li>
                                                </ul>
                                            </nav>

                                        </div>

                                    </div>

                                </Tab.Pane>

                                <Tab.Pane eventKey="outgoing">
                                    <div className="table-container">

                                        <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd' }}>
                                            <thead>
                                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                    <th className='min-w-80px'>Communicator</th>
                                                    <th className='min-w-100px'>Call Date</th>
                                                    <th className='min-w-100px'>Start Time</th>
                                                    <th className='min-w-100px'>End Time</th>
                                                    <th className='min-w-80px'>Duration</th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-gray-600 fw-semibold fs-7">
                                                {outgoing.length === 0 && hasFetched ? (
                                                    <tr>
                                                        <td colSpan="5" className="text-center text-muted py-2">
                                                            No data available
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    <>
                                                        {outgoing.map((data, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <div className="d-flex align-items-center justify-content-start gap-2">
                                                                        {renderCallStatusContent(data.call_status)}
                                                                        <div className='mb-0'>
                                                                            <label className='text-black font-w400 fs-7'>{data.staff_name}</label>
                                                                            <div className="d-block">
                                                                                <div className="fs-8 font-w600 text-dark">{data.staff_phone_no}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className='align-content-center'>
                                                                    <div className='text-black font-w400 fs-7  mw-75'>{formatDate(data.call_start_date)}</div>
                                                                </td>
                                                                <td className='align-content-center'>
                                                                    <div className='text-info font-w400 fs-7  mw-75'>{convert24to12(data.call_start_time)}</div>
                                                                </td>
                                                                <td className='align-content-center'>
                                                                    <div className='text-danger font-w400 fs-7  mw-75'>{convert24to12(data.call_end_time)}</div>
                                                                </td>
                                                                <td className='align-content-center'>
                                                                    <Badge bg="warning" className='text-white fs-7 font-w400 mw-75'>{data.call_duration}</Badge>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </>
                                                )}

                                                {loading && (
                                                    <tr>
                                                        <td colSpan="5" className="text-center text-muted py-2">
                                                            Loading
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>

                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            {/* Bottom left: Showing x to y of z entries */}
                                            <div>
                                                {outgoing.length > 0 ? (
                                                    <span className="text-muted">
                                                        Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + outgoing.length} of {total_entries} entries
                                                    </span>
                                                ) : (
                                                    <span className="text-muted">
                                                        Showing 0 to 0 of 0 entries
                                                    </span>
                                                )}
                                            </div>

                                            {/* Bottom right: Pagination */}
                                            <nav>
                                                <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                    {/* Previous Button */}
                                                    <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                                            Previous
                                                        </button>
                                                    </li>

                                                    {/* First Page */}
                                                    <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                                            1
                                                        </button>
                                                    </li>

                                                    {/* Left Ellipsis */}
                                                    {page > 4 && (
                                                        <li className="page-item disabled">
                                                            <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                        </li>
                                                    )}

                                                    {/* Pages Around Current */}
                                                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                        .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                                        .map(p => (
                                                            <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                                    {p}
                                                                </button>
                                                            </li>
                                                        ))}

                                                    {/* Right Ellipsis */}
                                                    {page < totalPages - 3 && (
                                                        <li className="page-item disabled">
                                                            <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                        </li>
                                                    )}

                                                    {/* Last Page */}
                                                    {totalPages > 1 && (
                                                        <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                                                {totalPages}
                                                            </button>
                                                        </li>
                                                    )}

                                                    {/* Next Button */}
                                                    <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                                            Next
                                                        </button>
                                                    </li>
                                                </ul>
                                            </nav>

                                        </div>

                                    </div>
                                </Tab.Pane>

                                <Tab.Pane eventKey="missed">
                                    <div className="table-container">

                                        <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd' }}>
                                            <thead>
                                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                    <th className='min-w-80px'>Communicator</th>
                                                    <th className='min-w-100px'>Call Date</th>
                                                    <th className='min-w-100px'>Start Time</th>
                                                    <th className='min-w-100px'>End Time</th>
                                                    <th className='min-w-80px'>Duration</th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-gray-600 fw-semibold fs-7">
                                                {missed.length === 0 && hasFetched ? (
                                                    <tr>
                                                        <td colSpan="5" className="text-center text-muted py-2">
                                                            No data available
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    <>
                                                        {missed.map((data, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <div className="d-flex align-items-center justify-content-start gap-2">
                                                                        {renderCallStatusContent(data.call_status)}
                                                                        <div className='mb-0'>
                                                                            <label className='text-black font-w400 fs-7'>{data.staff_name}</label>
                                                                            <div className="d-block">
                                                                                <div className="fs-8 font-w600 text-dark">{data.staff_phone_no}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className='align-content-center'>
                                                                    <div className='text-black font-w400 fs-7  mw-75'>{formatDate(data.call_start_date)}</div>
                                                                </td>
                                                                <td className='align-content-center'>
                                                                    <div className='text-info font-w400 fs-7  mw-75'>{convert24to12(data.call_start_time)}</div>
                                                                </td>
                                                                <td className='align-content-center'>
                                                                    <div className='text-danger font-w400 fs-7  mw-75'>{convert24to12(data.call_end_time)}</div>
                                                                </td>
                                                                <td className='align-content-center'>
                                                                    <Badge bg="warning" className='text-white fs-7 font-w400 mw-75'>{data.call_duration}</Badge>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </>
                                                )}

                                                {loading && (
                                                    <tr>
                                                        <td colSpan="5" className="text-center text-muted py-2">
                                                            Loading
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>

                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            {/* Bottom left: Showing x to y of z entries */}
                                            <div>
                                                {missed.length > 0 ? (
                                                    <span className="text-muted">
                                                        Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + missed.length} of {total_entries} entries
                                                    </span>
                                                ) : (
                                                    <span className="text-muted">
                                                        Showing 0 to 0 of 0 entries
                                                    </span>
                                                )}
                                            </div>

                                            {/* Bottom right: Pagination */}
                                            <nav>
                                                <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                    {/* Previous Button */}
                                                    <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                                            Previous
                                                        </button>
                                                    </li>

                                                    {/* First Page */}
                                                    <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                                            1
                                                        </button>
                                                    </li>

                                                    {/* Left Ellipsis */}
                                                    {page > 4 && (
                                                        <li className="page-item disabled">
                                                            <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                        </li>
                                                    )}

                                                    {/* Pages Around Current */}
                                                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                        .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                                        .map(p => (
                                                            <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                                    {p}
                                                                </button>
                                                            </li>
                                                        ))}

                                                    {/* Right Ellipsis */}
                                                    {page < totalPages - 3 && (
                                                        <li className="page-item disabled">
                                                            <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                        </li>
                                                    )}

                                                    {/* Last Page */}
                                                    {totalPages > 1 && (
                                                        <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                                                {totalPages}
                                                            </button>
                                                        </li>
                                                    )}

                                                    {/* Next Button */}
                                                    <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                                            Next
                                                        </button>
                                                    </li>
                                                </ul>
                                            </nav>

                                        </div>

                                    </div>
                                </Tab.Pane>

                                <Tab.Pane eventKey="dailed">
                                    <div className="table-container">

                                        <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd' }}>
                                            <thead>
                                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                    <th className='min-w-80px'>Communicator</th>
                                                    <th className='min-w-100px'>Call Date</th>
                                                    <th className='min-w-100px'>Start Time</th>
                                                    <th className='min-w-100px'>End Time</th>
                                                    <th className='min-w-80px'>Duration</th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-gray-600 fw-semibold fs-7">
                                                {dailed.length === 0 && hasFetched ? (
                                                    <tr>
                                                        <td colSpan="5" className="text-center text-muted py-2">
                                                            No data available
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    <>
                                                        {dailed.map((data, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <div className="d-flex align-items-center justify-content-start gap-2">
                                                                        {renderCallStatusContent(data.call_status)}
                                                                        <div className='mb-0'>
                                                                            <label className='text-black font-w400 fs-7'>{data.staff_name}</label>
                                                                            <div className="d-block">
                                                                                <div className="fs-8 font-w600 text-dark">{data.staff_phone_no}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className='align-content-center'>
                                                                    <div className='text-black font-w400 fs-7  mw-75'>{formatDate(data.call_start_date)}</div>
                                                                </td>
                                                                <td className='align-content-center'>
                                                                    <div className='text-info font-w400 fs-7  mw-75'>{convert24to12(data.call_start_time)}</div>
                                                                </td>
                                                                <td className='align-content-center'>
                                                                    <div className='text-danger font-w400 fs-7  mw-75'>{convert24to12(data.call_end_time)}</div>
                                                                </td>
                                                                <td className='align-content-center'>
                                                                    <Badge bg="warning" className='text-white fs-7 font-w400 mw-75'>{data.call_duration}</Badge>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </>
                                                )}

                                                {loading && (
                                                    <tr>
                                                        <td colSpan="5" className="text-center text-muted py-2">
                                                            Loading
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>

                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            {/* Bottom left: Showing x to y of z entries */}
                                            <div>
                                                {dailed.length > 0 ? (
                                                    <span className="text-muted">
                                                        Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + dailed.length} of {total_entries} entries
                                                    </span>
                                                ) : (
                                                    <span className="text-muted">
                                                        Showing 0 to 0 of 0 entries
                                                    </span>
                                                )}
                                            </div>

                                            {/* Bottom right: Pagination */}
                                            <nav>
                                                <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                    {/* Previous Button */}
                                                    <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                                            Previous
                                                        </button>
                                                    </li>

                                                    {/* First Page */}
                                                    <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                                            1
                                                        </button>
                                                    </li>

                                                    {/* Left Ellipsis */}
                                                    {page > 4 && (
                                                        <li className="page-item disabled">
                                                            <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                        </li>
                                                    )}

                                                    {/* Pages Around Current */}
                                                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                        .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                                        .map(p => (
                                                            <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                                    {p}
                                                                </button>
                                                            </li>
                                                        ))}

                                                    {/* Right Ellipsis */}
                                                    {page < totalPages - 3 && (
                                                        <li className="page-item disabled">
                                                            <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                        </li>
                                                    )}

                                                    {/* Last Page */}
                                                    {totalPages > 1 && (
                                                        <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                                                {totalPages}
                                                            </button>
                                                        </li>
                                                    )}

                                                    {/* Next Button */}
                                                    <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                                            Next
                                                        </button>
                                                    </li>
                                                </ul>
                                            </nav>

                                        </div>

                                    </div>
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </div>
                </Col>
            </div>
        </Modal>
    );
};

export default Cronjob_logs;
